<template>
  <div class="HTML_MEDIAVIDEO">
    <template v-if="datas.videos && datas.videos.length > 0">
      <video_aliplayer_v2
        :options="{
          // source: '//player.alicdn.com/video/editor.mp4',
          source: datas.videos[1] ? datas.videos[1] : '',
          cover: datas.videos[0] ? datas.videos[0] : '',
        }"
      ></video_aliplayer_v2>
    </template>
    <template v-else>
      <img :src="datas.pictures[0] ? datas.pictures[0] : ''" />
    </template>
  </div>
</template>

<script>
import video_aliplayer_v2 from '@components/base/video_aliplayer_v2.vue'
// 媒体云下广播级 图片
export default {
  props: {
    datas: {
      // 必传参数，球员的所有信息放到一个对象里
      type: Object,
      default: () => ({
        objectInfo: [],
        data: {
          dataList: [],
        },
        statisticsModels: [],
        pictures: [],
        videos: [],
      }),
    },
  },
  components: {
    video_aliplayer_v2,
  },

  created() {
    console.debug('HTML_MEDIAVIDEO:', this.datas)
  },
  data() {
    return {}
  },
}
</script>

<style lang="scss" scoped>
.HTML_MEDIAVIDEO {
  position: relative;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  align-items: center;
  width: calc(100% - 3.6vw);
  height: calc(100% - 1.8vw);
  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}
</style>
